import { Area } from '../models/filter/location/area/Area';
import { Continent } from '../models/filter/location/continent/Continent';
import { Country } from '../models/filter/location/country/Country';
import { Discipline } from '../models/filter/discipline/Discipline';
import DisciplinesRepository from '../infrastructure/DisciplinesRepository';
import LocationRepository from '../infrastructure/LocationRepository';
import { IDisciplinesRepository, ILocationRepository } from '../interfaces/presenters.interfaces';

class FiltersDataPresenter {
	public constructor(
		private disciplinesRepository: IDisciplinesRepository,
		private locationRepository: ILocationRepository,
	) {}

	public getDisciplines(): Discipline[] {
		return this.disciplinesRepository.getDisciplines();
	}

	public getContinents(): Continent[] {
		return this.locationRepository.getContinents();
	}

	public getAreas(): Area[] {
		return this.locationRepository.getAreas();
	}

	public getCountries(): Country[] {
		return this.locationRepository.getCountries();
	}
}

export default new FiltersDataPresenter(DisciplinesRepository, LocationRepository);
